import styled from 'styled-components';

import { COLORS, ANIM, MOBILE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** Footer beneath the settings list: the legal / data-request links (Privacy Policy ·
 *  Terms & Conditions · Data Deletion). On desktop they sit on one centred row split by
 *  middle-dots, set a little clear of the last list row. On mobile each link gets its own
 *  full-width row (no bullets), with extra top whitespace so they read as separate from the
 *  settings options above. */
export const LegalFooter = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 8px;

  ${MOBILE} {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 0;
    margin-top: 20px;
  }
`;

/** A legal link: a 48px-tall touch target rendering 14px copy. Colour comes from
 *  the themed muted token (so it reads in light AND dark) and brightens on
 *  hover/focus; the inner label inherits it. On mobile it stretches to a full-width
 *  row with the copy centred. */
export const LegalLink = styled.a`
  display: inline-flex;
  align-items: center;
  min-height: 48px;
  padding: 0 8px;
  text-decoration: none;
  color: ${COLORS.textMuted};
  transition: color ${ANIM.INTERACT_MS}ms ease;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: ${COLORS.text};
  }

  ${MOBILE} {
    justify-content: center;
  }
`;

export const LinkLabel = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: inherit;
`;

/** Middle-dot separator between the two links (decorative, non-interactive).
 *  Hidden on mobile, where the links stack onto their own rows. */
export const Bullet = styled.span`
  font-size: 14px;
  line-height: 1;
  color: ${COLORS.textFaint};
  user-select: none;

  ${MOBILE} {
    display: none;
  }
`;
